personal = {
	init() {
		$('.js-personal-tab').on('click', function(event) {
			if (!$(event.currentTarget).hasClass('active'))
				$('.js-personal-tab-item').toggleClass('active');
		});

		$('.register-promocode__btn').click(function(){
			$(this).closest('.register-promocode').toggleClass('active');
		});


		//отправка кода в файле form.js checkPromocode
		$('.register-promocode__field input').change(function(){
			if (!$(this).val().trim())
				$(this).closest('.register-promocode').removeClass('active');

		});
		// $('.register-promocode__field input').blur(function(){
		// 	let parent = $(this).closest('.register-promocode');
		//
		//
		// 	if (parent.hasClass('error'))
		// 		parent.removeClass('error').addClass('ok');
		// 	else
		// 		parent.removeClass('ok').addClass('error');
		//
		//
		// });


	}
}
// const rand = (x, y) => {
// 	return parseInt(Math.random() * (y + 1 - x) + x, 10);
// }

$(document).ready(function () {
	personal.init();
});

//Открытие формы заполнение инфо при $_GET edit=y и убираем пар-р
document.addEventListener("DOMContentLoaded", function() {
	const urlParams = new URLSearchParams(window.location.search);
	if (urlParams.get('edit') === 'y') {
		const editBtn = document.querySelector('.personal-human__btn-edit');
		if (editBtn) {
			editBtn.click();
			urlParams.delete('edit');
			const newQuery = urlParams.toString();
			const newUrl = window.location.pathname + (newQuery ? '?' + newQuery : '') + window.location.hash;
			window.history.replaceState({ path: newUrl }, '', newUrl);
		}
	}
});
